<template>
  <div class="app-page store">
    <div class="app-page-header">
      <img src="../assets/login/back.png" @click="back"/>
      <span class="title">所属门店</span>
      <img src="../assets/login/back.png" style="visibility: hidden"/>
    </div>
    <div class="app-page-content">
      <div class="search">
        <div class="search-box">
          <div class="input-box">
            <img src="../assets/login/search.png"/>
            <input type="text" name="storeName" placeholder="请输入门店名称" v-model="keyWords" class="xc-btn searchText"/>
          </div>
          <input type="button" @click="search" value="搜索" class="xc-btn searchButton"/>
        </div>
      </div>
      <div class="app-card" v-show="!searched">
        <div class="store-item" v-for="(item,index) in list" :key="index"  @click="choose" :data-store="JSON.stringify(item)">
          {{item.storeName}}
        </div>
      </div>
      <div class="app-card" v-show="searched">
        <div class="store-item" v-for="(item,index) in results" :key="index" @click="choose" :data-store="JSON.stringify(item)">
          {{item.storeName}}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'store',
    data(){
      return{
        store:{},
        list:[],
        keyWords:"",
        results:[],
        searched:false,
      }
    },
    methods:{
      //返回
      back:function(e){
        e.stopPropagation();
        this.$emit("back");
      },
      //搜索
      search:function(){
        this.results=[];
        this.searched=true;
        var key=this.keyWords;
        for(let x of this.list){
          if(x.storeName.indexOf(key)!=-1){
            this.results.push(x)
          }
        }
      },
      //  选择设备类型
      choose:function (e) {
        e.stopPropagation();
        var value=e.target.dataset.store;
        this.store=JSON.parse(value);
        this.store.type=1;
        this.$emit("choose",this.store)
      }
    },
    mounted(){
      //  请求门店列表
      var _this=this;
      this.$http.post("/store/list",{
        pageSize:0,
        status:0
      },{}).then(function (res) {
        _this.list=res.data.list;
      }).catch(function (result) {
      })
    },
    created(){

    }
  }
</script>

<style scoped lang="scss">
.store{
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100vh;
  background: #eeeeee;
  z-index: 999;
  display: flex;
  flex-direction: column;
  .app-page-content{
    flex: 1;
    display: flex;
    flex-direction: column;
    .search{
     background: #ffffff;
      margin-bottom: 8px;
      padding: 0 15px;
      .search-box{
        display: flex;
        justify-content: space-between;
        height: 52px;
        align-items: center;
        input{
          height: 33.5px;
        }
        .input-box{
          position: relative;
          flex: 1;
          img{
            position: absolute;
            left: 10px;
            width: 12px;
            top: 50%;
            margin-top: -6px;
          }
          .searchText{
            font-size: 12px;
            padding-left: 32px;
            padding-right: 10px;
            color: #333333;
          }
        }
        .searchButton{
          margin-left: 15px;
          width: 52px;
          padding: 0;
          text-align: center;
          color: #ffffff;
          background: #1655bf;
        }
      }
    }
    .app-card{
      flex: 1;
      overflow: auto;
      background: #ffffff;
      .store-item{
        padding: 0 15px;
        height: 44px;
        font-size: 14px;
        display: flex;
        align-items: center;
        border-bottom: 1px solid #ececec;
      }
    }
  }
}
</style>
